// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/advantages/alternative-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/advantages/chemicalfree-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Assets/advantages/quality-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Assets/advantages/hygiene-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advantages-container{
    position: relative;
    width:100vw;
    height:100%;
    padding-top:20px;
    
}

.advantages-container ::before{
    content: '';
        /* Required to display the pseudo-element */
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 90%;
        /* background-image: url('../Assets/Home-Page/background\\ .png'); */
        background-color: #FFEBEE;
        /* Set your background image */
        background-size: cover;
        /* Ensure the image covers the entire container */
        background-position: center;
        /* Center the image */
        opacity: 0.01;
        /* Set the opacity of the background image */
        z-index: -1;
}



.advantage-header h1{
    font-family: 'Philosopher',serif;
    font-style: italic;
    font-weight: 700;
    
    font-size: 35px;
    z-index: 1;
    margin: 10px;
    
}

.advantage-header h1 span{
    font-family: 'Philosopher', serif;
        font-style: italic;
        font-weight: 700;
        font-size: 35px;
        z-index: 1;
}

.advantage-cards{
    display: flex;
    justify-content:space-evenly;
    margin-top: 40px;

}

.alternative-card{
    width:20%;
    height:400px;
    display: flex;
    flex-direction: column;
    
    align-items: center;
    margin-top:200px;
    padding-top: 0px;
}

.alternative-card-icon {
    width:100px;
    height:100px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

}

.alternative-card h3{
    text-align: left;
    font-family: 'Philosopher',serif;
    font-weight: 700;
    font-size: 22px;
    font-style: italic;
    
}

.alternative-card p{
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top:-10px;
    color:#666666;
    

}

.alternative-card p{
    text-align: center;
}

.chemicalfree-card {
    width: 20%;
    height: 400px;
    display: flex;
    flex-direction: column;
    
    align-items: center;
}

.chemicalfree-card-icon {
    width: 100px;
    height: 100px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

}

.chemicalfree-card h3 {
    text-align: left;
    font-family: 'Philosopher', serif;
    font-weight: 700;
    font-size: 22px;
    font-style: italic;

}

.chemicalfree-card p {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top: -10px;
    color: #666666;


}

.chemicalfree-card p {
    text-align: center;
}

.quality-card {
    width: 20%;
    height: 400px;
    display: flex;
    flex-direction: column;
    
    align-items: center;
}

.quality-card-icon {
    width: 100px;
    height: 100px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

}

.quality-card h3 {
    text-align: left;
    font-family: 'Philosopher', serif;
    font-weight: 700;
    font-size: 22px;
    font-style: italic;

}

.quality-card p {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top: -10px;
    color: #666666;


}

.quality-card p {
    text-align: center;
}


.hygiene-card {
    width: 20%;
    height: 400px;
    display: flex;
    flex-direction: column;
    
    align-items: center;
    margin-top: 200px;
}

.hygiene-card-icon {
    width: 100px;
    height: 100px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

}

.hygiene-card h3 {
    text-align: left;
    font-family: 'Philosopher', serif;
    font-weight: 700;
    font-size: 22px;
    font-style: italic;

}

.hygiene-card p {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top: -10px;
    color: #666666;


}

.hygiene-card p {
    text-align: center;
}

.allproducts-image{
    margin-top:-450px;
    z-index: 3;
    opacity: 1;
   
   
}

@media screen and (max-width:768px){
    .advantage-cards {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            margin-top: 40px;
    
        }
        .advantages-container ::before {
            content: '';
            /* Required to display the pseudo-element */
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            /* background-image: url('../Assets/Home-Page/background\\ .png'); */
            background-color: #FFEBEE;
            /* Set your background image */
            background-size: cover;
            /* Ensure the image covers the entire container */
            background-position: center;
            /* Center the image */
            opacity: 0.01;
            /* Set the opacity of the background image */
            z-index: -1;
        }
        .alternative-card {
            width: 80%;
            height: 100%;
            display: flex;
            flex-direction: column;
    
            align-items: center;
            margin-top: 20px;
            padding-top: 0px;
        }
        .chemicalfree-card {
            width: 80%;
            height: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 0px;
    
            align-items: center;
        }
        .quality-card {
            width: 80%;
            height: 100%;
            display: flex;
            flex-direction: column;
    
            align-items: center;
        }
        .hygiene-card {
            width: 80%;
            height: 100%;
            display: flex;
            flex-direction: column;
    
            align-items: center;
            margin-top: 0px;
        }
        .allproducts-image {
            width:100%;
            margin-top: -0px;
            z-index: 3;
            opacity: 1;
    
    
        }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Advantages.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;QACP,2CAA2C;QAC3C,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,WAAW;QACX,mEAAmE;QACnE,yBAAyB;QACzB,8BAA8B;QAC9B,sBAAsB;QACtB,iDAAiD;QACjD,2BAA2B;QAC3B,qBAAqB;QACrB,aAAa;QACb,4CAA4C;QAC5C,WAAW;AACnB;;;;AAIA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;;IAEhB,eAAe;IACf,UAAU;IACV,YAAY;;AAEhB;;AAEA;IACI,iCAAiC;QAC7B,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,UAAU;AAClB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;;AAEpB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAwE;IACxE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;;;AAGjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAyE;IACzE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAoE;IACpE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAoE;IACpE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;;;AAGlB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,UAAU;;;AAGd;;AAEA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,6BAA6B;YAC7B,mBAAmB;YACnB,gBAAgB;;QAEpB;QACA;YACI,WAAW;YACX,2CAA2C;YAC3C,kBAAkB;YAClB,MAAM;YACN,OAAO;YACP,WAAW;YACX,YAAY;YACZ,mEAAmE;YACnE,yBAAyB;YACzB,8BAA8B;YAC9B,sBAAsB;YACtB,iDAAiD;YACjD,2BAA2B;YAC3B,qBAAqB;YACrB,aAAa;YACb,4CAA4C;YAC5C,WAAW;QACf;QACA;YACI,UAAU;YACV,YAAY;YACZ,aAAa;YACb,sBAAsB;;YAEtB,mBAAmB;YACnB,gBAAgB;YAChB,gBAAgB;QACpB;QACA;YACI,UAAU;YACV,YAAY;YACZ,aAAa;YACb,sBAAsB;YACtB,eAAe;;YAEf,mBAAmB;QACvB;QACA;YACI,UAAU;YACV,YAAY;YACZ,aAAa;YACb,sBAAsB;;YAEtB,mBAAmB;QACvB;QACA;YACI,UAAU;YACV,YAAY;YACZ,aAAa;YACb,sBAAsB;;YAEtB,mBAAmB;YACnB,eAAe;QACnB;QACA;YACI,UAAU;YACV,gBAAgB;YAChB,UAAU;YACV,UAAU;;;QAGd;AACR","sourcesContent":[".advantages-container{\n    position: relative;\n    width:100vw;\n    height:100%;\n    padding-top:20px;\n    \n}\n\n.advantages-container ::before{\n    content: '';\n        /* Required to display the pseudo-element */\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 90%;\n        /* background-image: url('../Assets/Home-Page/background\\ .png'); */\n        background-color: #FFEBEE;\n        /* Set your background image */\n        background-size: cover;\n        /* Ensure the image covers the entire container */\n        background-position: center;\n        /* Center the image */\n        opacity: 0.01;\n        /* Set the opacity of the background image */\n        z-index: -1;\n}\n\n\n\n.advantage-header h1{\n    font-family: 'Philosopher',serif;\n    font-style: italic;\n    font-weight: 700;\n    \n    font-size: 35px;\n    z-index: 1;\n    margin: 10px;\n    \n}\n\n.advantage-header h1 span{\n    font-family: 'Philosopher', serif;\n        font-style: italic;\n        font-weight: 700;\n        font-size: 35px;\n        z-index: 1;\n}\n\n.advantage-cards{\n    display: flex;\n    justify-content:space-evenly;\n    margin-top: 40px;\n\n}\n\n.alternative-card{\n    width:20%;\n    height:400px;\n    display: flex;\n    flex-direction: column;\n    \n    align-items: center;\n    margin-top:200px;\n    padding-top: 0px;\n}\n\n.alternative-card-icon {\n    width:100px;\n    height:100px;\n    background-image: url('../Assets/advantages/alternative-background.png');\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.alternative-card h3{\n    text-align: left;\n    font-family: 'Philosopher',serif;\n    font-weight: 700;\n    font-size: 22px;\n    font-style: italic;\n    \n}\n\n.alternative-card p{\n    font-family: 'Poppins',sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top:-10px;\n    color:#666666;\n    \n\n}\n\n.alternative-card p{\n    text-align: center;\n}\n\n.chemicalfree-card {\n    width: 20%;\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    \n    align-items: center;\n}\n\n.chemicalfree-card-icon {\n    width: 100px;\n    height: 100px;\n    background-image: url('../Assets/advantages/chemicalfree-background.png');\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.chemicalfree-card h3 {\n    text-align: left;\n    font-family: 'Philosopher', serif;\n    font-weight: 700;\n    font-size: 22px;\n    font-style: italic;\n\n}\n\n.chemicalfree-card p {\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: -10px;\n    color: #666666;\n\n\n}\n\n.chemicalfree-card p {\n    text-align: center;\n}\n\n.quality-card {\n    width: 20%;\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    \n    align-items: center;\n}\n\n.quality-card-icon {\n    width: 100px;\n    height: 100px;\n    background-image: url('../Assets/advantages/quality-background.png');\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.quality-card h3 {\n    text-align: left;\n    font-family: 'Philosopher', serif;\n    font-weight: 700;\n    font-size: 22px;\n    font-style: italic;\n\n}\n\n.quality-card p {\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: -10px;\n    color: #666666;\n\n\n}\n\n.quality-card p {\n    text-align: center;\n}\n\n\n.hygiene-card {\n    width: 20%;\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    \n    align-items: center;\n    margin-top: 200px;\n}\n\n.hygiene-card-icon {\n    width: 100px;\n    height: 100px;\n    background-image: url('../Assets/advantages/hygiene-background.png');\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.hygiene-card h3 {\n    text-align: left;\n    font-family: 'Philosopher', serif;\n    font-weight: 700;\n    font-size: 22px;\n    font-style: italic;\n\n}\n\n.hygiene-card p {\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: -10px;\n    color: #666666;\n\n\n}\n\n.hygiene-card p {\n    text-align: center;\n}\n\n.allproducts-image{\n    margin-top:-450px;\n    z-index: 3;\n    opacity: 1;\n   \n   \n}\n\n@media screen and (max-width:768px){\n    .advantage-cards {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-evenly;\n            align-items: center;\n            margin-top: 40px;\n    \n        }\n        .advantages-container ::before {\n            content: '';\n            /* Required to display the pseudo-element */\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            /* background-image: url('../Assets/Home-Page/background\\ .png'); */\n            background-color: #FFEBEE;\n            /* Set your background image */\n            background-size: cover;\n            /* Ensure the image covers the entire container */\n            background-position: center;\n            /* Center the image */\n            opacity: 0.01;\n            /* Set the opacity of the background image */\n            z-index: -1;\n        }\n        .alternative-card {\n            width: 80%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n    \n            align-items: center;\n            margin-top: 20px;\n            padding-top: 0px;\n        }\n        .chemicalfree-card {\n            width: 80%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            margin-top: 0px;\n    \n            align-items: center;\n        }\n        .quality-card {\n            width: 80%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n    \n            align-items: center;\n        }\n        .hygiene-card {\n            width: 80%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n    \n            align-items: center;\n            margin-top: 0px;\n        }\n        .allproducts-image {\n            width:100%;\n            margin-top: -0px;\n            z-index: 3;\n            opacity: 1;\n    \n    \n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
